import React, { useEffect, useState } from "react";
import AvatarCircle from "./AvatarCircle";
import { useCookies, withCookies } from "react-cookie";

const PendingFollowRequestsComponent = ({ api }) => {

  const [cookies] = useCookies()
  const [requests, setRequests] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const resp = await api().listMyPendingFollows(cookies.token)
        if (resp.status === 200) {
          setRequests(
            resp.data.map((data) => (
              {
                id: data._id,
                name: `${data.creator.firstName} ${data.creator.lastName}`,
                subtitle: data.creator.username
              }
            ))
          )
        }
      } catch (e) {

      }

    })()
  }, [refreshTrigger])

  // Mock list of pending requests


  // Handle Accept action
  const handleAccept = async (id) => {
    try {
      const resp = await api().performFollowAction(cookies.token, id, "accept")
      setRefreshTrigger((prev) => prev + 1)
    } catch (e) {

    }
  };

  // Handle Ignore action
  const handleIgnore = async (id) => {
     try {
      const resp = await api().performFollowAction(cookies.token, id, "decline")
      setRefreshTrigger((prev) => prev + 1)
    } catch (e) {
      
    }
  };

  return (
    <div className="max-w-2xl mx-auto  bg-white rounded-lg">
      <h1 className="text-lg font-semibold text-gray-800">Pending follow requests</h1>

      {requests.length > 0 ? (
        <ul className="">
          {requests.map((request) => (
            <li
              key={request.id}
              className="flex items-center justify-between p-4 "
            >
              {/* Avatar */}
              <AvatarCircle letters={request.name} size={"size-12"} />

              {/* User Info */}
              <div className="flex-1 ml-4">
                <h2 className="text-lg font-medium">{request.name}</h2>
                <p className="text-sm text-gray-500">{request.subtitle}</p>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-2">
                <button
                  onClick={() => handleAccept(request.id)}
                  className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                >
                  Accept
                </button>
                <button
                  onClick={() => handleIgnore(request.id)}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Ignore
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500 p-4">No pending follow requests.</p>
      )}
    </div>
  );
}

const PendingFollowRequests = withCookies(({ api }) => (
  <PendingFollowRequestsComponent api={api} />
))

export default PendingFollowRequests;